import React from "react";
import PropTypes from "prop-types";

import RechargeValueList from "../RechargeValueList/RechargeValueList";
import ProductTVList from "../ProductTVList/ProductTVList";
import InfoBenefitList from "../InfoBenefitList/InfoBenefitList";
import { isControlChannel } from "../../../../lib/utils";

const PlanList = ({
  rechargeValues,
  callRechargeValue,
  productTVValues,
  callProductTVValue,
  benefits,
  callBenefit,
  media,
  channel,
}) => {
  return (
    <>
      <RechargeValueList
        rechargeValues={rechargeValues}
        onClick={callRechargeValue}
        media={media}
      />
      <ProductTVList productTVValues={productTVValues} onClick={callProductTVValue} media={media} />
      {!isControlChannel(channel) && (
        <InfoBenefitList infoBenefits={benefits} onClick={callBenefit} media={media} />
      )}
    </>
  );
};

PlanList.propTypes = {
  rechargeValues: PropTypes.array,
  callRechargeValue: PropTypes.func.isRequired,
  productTVValues: PropTypes.array,
  callProductTVValue: PropTypes.func.isRequired,
  benefits: PropTypes.array,
  callBenefit: PropTypes.func.isRequired,
  media: PropTypes.object.isRequired,
  channel: PropTypes.string.isRequired,
};

PlanList.defaultProps = {
  rechargeValues: [],
  productTVValues: [],
  benefits: [],
};

export default PlanList;
